module.exports = __webpack_public_path__ + "static/media/img1-3.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/CA/img1-3.png
// module id = 1639
// module chunks = 3